var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/member-compliance/member-compliance.html';
var html = "<div layout=column layout-padding> <div> <noncompliant-members companies=$ctrl.nonCompliantCompanies></noncompliant-members> <compliant-members companies=$ctrl.compliantCompanies></compliant-members> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/admin/member-compliance/member-compliance.html
// module id = 485
// module chunks = 0